module.exports = __webpack_public_path__ + "img/fi-xls.24521f36.svg";